import React from 'react';
import { NavLink } from 'react-router-dom';

const AdminSidebar = () => {
  const menuItems = [
    { path: '/admin/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/admin/features', label: 'Özellikler', icon: '⭐' },
    { path: '/admin/client-references', label: 'Referanslar', icon: '🏢' },
    { path: '/admin/integration-categories', label: 'Entegrasyon Kategorileri', icon: '📂' },
    { path: '/admin/integration-companies', label: 'Entegrasyon Firmaları', icon: '🔌' },
    { path: '/admin/faq-categories', label: 'FAQ Kategorileri', icon: '❓' },
    { path: '/admin/faq-questions', label: 'FAQ Soruları', icon: '💬' },
    { path: '/admin/banks', label: 'Bankalar', icon: '🏛️' },
    { path: '/admin/bank-accounts', label: 'Banka Hesapları', icon: '🏦' },
    { path: '/admin/contact-info', label: 'İletişim Bilgileri', icon: '📞' },
    { path: '/admin/users', label: 'Kullanıcılar', icon: '👥' },
  ];

  return (
    <aside style={{
      width: '16rem',
      backgroundColor: 'white',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
      minHeight: '100vh'
    }}>
      <div style={{ padding: '1rem' }}>
        <nav style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              style={({ isActive }) => ({
                display: 'flex',
                alignItems: 'center',
                padding: '0.75rem',
                borderRadius: '0.375rem',
                fontSize: '0.875rem',
                textDecoration: 'none',
                transition: 'all 0.2s',
                backgroundColor: isActive ? '#eff6ff' : 'transparent',
                color: isActive ? '#1d4ed8' : '#6b7280',
                fontWeight: isActive ? '500' : '400',
                borderRight: isActive ? '2px solid #1d4ed8' : '2px solid transparent'
              })}
              onMouseOver={(e) => {
                if (!e.target.style.backgroundColor.includes('eff6ff')) {
                  e.target.style.backgroundColor = '#f9fafb';
                  e.target.style.color = '#111827';
                }
              }}
              onMouseOut={(e) => {
                if (!e.target.style.backgroundColor.includes('eff6ff')) {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#6b7280';
                }
              }}
            >
              <span style={{ marginRight: '0.75rem', fontSize: '1rem' }}>{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </aside>
  );
};

export default AdminSidebar;

